export default class PaymentMethod {
  /** @type {string?} */ formaPago = null
  /** @type {string?} */ iban = null
  /** @type {string?} */ bicSwift = null
  /** @type {string?} */ fechaMandato = null
  /** @type {string?} */ dateVencimiento = null
  /** @type {boolean?} */ toBeCredit = null
}  
